import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  FormHelperText,
  Input,
  Select,
  Box,
  Flex,
  Image,
  Text,
  Button,
  Card,
  CardBody,
  SimpleGrid,
  Textarea,
  Checkbox,
  CheckboxGroup,
  useDisclosure,
} from "@chakra-ui/react";
import { toast } from "react-hot-toast";
import { useSelector } from "react-redux";

import axios from "axios";
import Cookie from "js-cookie";
import "react-calendar/dist/Calendar.css";
import Calendar from "react-calendar";
import React, { useState, useEffect } from "react";
import { FaPlus } from "react-icons/fa";
import FoodCategoryModal from "./categoryRegisterModal";

const FoodRegister = () => {
  // const [data1, setData1] = useState(new Date());
  // console.log(data1.toDateString());
  // const [data2, setData2] = useState(new Date());
  // console.log(data2.toDateString());
  // const [total, setTotal] = useState(0);
  // const [advance, setAdvance] = useState(0);
  //let dueAmount = 0;
  const [dueAmount, setDueAmount] = useState(0);
  const token = Cookie.get("token");
  const [selectedFile, setSelectedFile] = useState(null);
  const [imageURL, setImageURL] = useState(null);
  const [foodCategory, setFoodCategory] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [images, setImages] = useState([]);
  const customerId = localStorage.getItem("customerId");
  const { onOpen, isOpen, onClose } = useDisclosure({});
  const handlePost = async () => {
    try {
      setUploading(true);

      if (!selectedFile) {
        toast.error("Please select a file to upload.");
        return;
      }

      const formData = new FormData();
      formData.append("image", selectedFile); // Ensure 'image' matches the backend field name

      const response = await axios.post(
        "https://api.rasoi.launchlysoftware.in/upload", // Corrected URL
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      const data = response.data;

      // Update state with uploaded image URL
      setImageURL(data.filename); // Adjust based on backend response
      toast.success("Image uploaded successfully");
      console.log(data, "Upload response");
    } catch (err) {
      console.error("Upload failed:", err);
      toast.error("Image upload failed. Please try again.");
    } finally {
      setUploading(false);
    }
  };
  console.log(imageURL, "imageURL");
  const handleToggle = () => {
    onOpen();
  };
  const fetchCategory = async () => {
    try {
      const response = await axios.get(
        `https://api.rasoi.launchlysoftware.in/api/getFoodCategory/${customerId}`,
      );
      //  toast.success(response.data.message)
      setFoodCategory(response.data.foodCategory);
    } catch (error) {
      toast.error(error.message);
    }
  };
  useEffect(() => {
    fetchCategory();
  }, [customerId]);

  const [formData, setFormData] = useState({
    name: "",
    description: "",
    category: "",

    acRate: 0,
    nonAcRate: 0,
    sgst: 0,
    cgst: 0,
    nonAcSgst: 0,
    nonAcCgst: 0,
    acHalfRate: 0,
    acHalfSgst: 0,
    acHalfCgst: 0,
    nonAcHalfRate: 0,
    nonAcHalfCgst: 0,
    nonAcHalfSgst: 0,
    gstPercentage: 0,

    hsnNo: "",
    image: "",
    type: "",
    code: "",
    halfPlate: false,
  });
  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };
  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: checked, // Set formData.halfPlate to true/false based on checkbox state
    }));
  };

  const validateForm = () => {
    const requiredFields = [
      "name",
      "description",
      "category",

      "acRate",

      "type",
      "code",
    ];

    for (const field of requiredFields) {
      if (!formData[field]) {
        return false;
      }
    }
    return true;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    if (!validateForm()) {
      toast.error("Please fill in all required fields.");
      return;
    }
    e.preventDefault();
    // Here you can send formData to your backend server or process it further
    console.log("Form submitted with data:", formData);

    // Reset form after submission
    const updatedFormData = {
      ...formData,
      image: imageURL, // Directly use the updated imageURL here
    };
  };
  useEffect(() => {
    if (formData.gstPercentage >= 0) {
      setFormData((prev) => ({
        ...prev,
        sgst: formData.acRate * (formData.gstPercentage / 2 / 100).toFixed(2),
        cgst: formData.acRate * (formData.gstPercentage / 2 / 100).toFixed(2),
        nonAcSgst:
          formData.nonAcRate * (formData.gstPercentage / 2 / 100).toFixed(2),
        nonAcCgst:
          formData.nonAcRate * (formData.gstPercentage / 2 / 100).toFixed(2),

        acHalfCgst:
          formData.acHalfRate * (formData.gstPercentage / 2 / 100).toFixed(2),
        acHalfSgst:
          formData.acHalfRate * (formData.gstPercentage / 2 / 100).toFixed(2),
        nonAcHalfCgst:
          formData.nonAcHalfRate *
          (formData.gstPercentage / 2 / 100).toFixed(2),
        nonAcHalfSgst:
          formData.nonAcHalfRate *
          (formData.gstPercentage / 2 / 100).toFixed(2),
      }));
    }
  }, [
    formData.gstPercentage,
    formData.acRate,
    formData.nonAcRate,
    formData.acHalfRate,
    formData.nonAcHalfRate,
  ]);
  const save = async (e) => {
    e.preventDefault();
    const updatedFormData = {
      ...formData,
      image: imageURL, // Directly use the updated imageURL here
    };

    if (!validateForm()) {
      toast.error("Please fill in all required fields.");
      return;
    }
    try {
      const response = await axios.post(
        "https://api.rasoi.launchlysoftware.in/api/foodRegister",
        {
          customerId: customerId,
          data: updatedFormData,
        },
      );
      console.log("Data Submitted: ", response.data);
      toast.success(response.data.message);
      setFormData({
        name: "",
        description: "",
        category: "",

        acRate: "",
        nonAcRate: 0,
        sgst: 0,
        cgst: 0,
        nonAcCgst: 0,
        nonAcCgst: 0,
        image: "",

        type: "",
        code: "",
        acHalfRate: 0,
        acHalfSgst: 0,
        acHalfCgst: 0,
        nonAcHalfRate: 0,
        nonAcHalfCgst: 0,
        nonAcHalfSgst: 0,
        halfPlate: false,
        hsnNo: "",
        gstPercentage: 0,
      });
    } catch (error) {
      toast.error(error);
    }
  };

  return (
    <Box
      bg="#f7f7f7"
      p="4"
      color="black"
      width="full"
      height="100vh"
      overflow="hidden"
      display="flex"
      flexDirection="column"
    >
      <FormControl isRequired onSubmit={handleSubmit}>
        <Box overflowY="auto" maxH="calc(100vh - 100px)" pr={2}>
          <SimpleGrid columns={3} spacing={4}>
            <Box
              display="flex"
              alignItems="center"
              boxShadow="md"
              borderRadius="8px"
              bg="white"
              p={3}
            >
              <FormLabel mb="0" minW="100px">
                Food Name
              </FormLabel>
              <Input
                bg="#FAFAFA"
                placeholder="Food Name"
                border="1px solid #ffe4d9"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                size="sm"
              />
            </Box>

            <Box
              display="flex"
              alignItems="center"
              boxShadow="md"
              borderRadius="8px"
              bg="white"
              p={3}
              gridColumn="span 2"
            >
              <FormLabel mb="0" minW="100px">
                Description
              </FormLabel>
              <Textarea
                bg="#FAFAFA"
                placeholder="Description"
                border="1px solid #ffe4d9"
                name="description"
                value={formData.description}
                onChange={handleInputChange}
                size="sm"
                rows={1}
              />
            </Box>

            <Box
              display="flex"
              alignItems="center"
              boxShadow="md"
              borderRadius="8px"
              bg="white"
              p={3}
            >
              <FormLabel mb="0" minW="100px">
                Category
              </FormLabel>
              <Select
                bg="#FAFAFA"
                placeholder="Category"
                border="1px solid #ffe4d9"
                name="category"
                value={formData.category}
                onChange={handleInputChange}
                size="sm"
              >
                {foodCategory.map((item, index) => (
                  <option key={index} value={item.name}>
                    {item.name}
                  </option>
                ))}
              </Select>
              <Button
                ml={2}
                size="sm"
                colorScheme="blue"
                onClick={handleToggle}
              >
                <FaPlus />
              </Button>
            </Box>

            <Box
              display="flex"
              alignItems="center"
              boxShadow="md"
              borderRadius="8px"
              bg="white"
              p={3}
            >
              <FormLabel mb="0" minW="100px">
                Type
              </FormLabel>
              <Select
                bg="#FAFAFA"
                placeholder="Type"
                border="1px solid #ffe4d9"
                name="type"
                value={formData.type}
                onChange={handleInputChange}
                size="sm"
              >
                <option>Veg</option>
                <option>Non-Veg</option>
              </Select>
            </Box>

            <Box
              display="flex"
              alignItems="center"
              boxShadow="md"
              borderRadius="8px"
              bg="white"
              p={3}
            >
              <FormLabel mb="0" minW="100px">
                Code
              </FormLabel>
              <Input
                bg="#FAFAFA"
                placeholder="Code"
                border="1px solid #ffe4d9"
                name="code"
                value={formData.code}
                onChange={handleInputChange}
                size="sm"
              />
            </Box>

            <Box
              display="flex"
              alignItems="center"
              boxShadow="md"
              borderRadius="8px"
              bg="white"
              p={3}
            >
              <FormLabel mb="0" minW="100px">
                GST %
              </FormLabel>
              <Input
                bg="#FAFAFA"
                placeholder="GST %"
                border="1px solid #ffe4d9"
                name="gstPercentage"
                value={formData.gstPercentage}
                onChange={handleInputChange}
                size="sm"
              />
            </Box>

            <Box
              display="flex"
              alignItems="center"
              boxShadow="md"
              borderRadius="8px"
              bg="white"
              p={3}
            >
              <FormLabel mb="0" minW="100px">
                HSN No
              </FormLabel>
              <Input
                bg="#FAFAFA"
                placeholder="HSN No"
                border="1px solid #ffe4d9"
                name="hsnNo"
                value={formData.hsnNo}
                onChange={handleInputChange}
                size="sm"
              />
            </Box>

            <Box
              display="flex"
              alignItems="center"
              boxShadow="md"
              borderRadius="8px"
              bg="white"
              p={3}
            >
              <FormLabel mb="0" minW="100px">
                Rate
              </FormLabel>
              <Input
                bg="#FAFAFA"
                placeholder="Rate"
                border="1px solid #ffe4d9"
                name="acRate"
                value={formData.acRate}
                onChange={handleInputChange}
                size="sm"
              />
            </Box>

            <Box
              display="flex"
              alignItems="center"
              boxShadow="md"
              borderRadius="8px"
              bg="white"
              p={3}
            >
              <FormLabel mb="0" minW="100px">
                SGST
              </FormLabel>
              <Input
                bg="#FAFAFA"
                placeholder="SGST"
                border="1px solid #ffe4d9"
                name="sgst"
                value={formData.sgst.toFixed(2)}
                onChange={handleInputChange}
                size="sm"
                isReadOnly
              />
            </Box>

            <Box
              display="flex"
              alignItems="center"
              boxShadow="md"
              borderRadius="8px"
              bg="white"
              p={3}
            >
              <FormLabel mb="0" minW="100px">
                CGST
              </FormLabel>
              <Input
                bg="#FAFAFA"
                placeholder="CGST"
                border="1px solid #ffe4d9"
                name="cgst"
                value={formData.cgst.toFixed(2)}
                onChange={handleInputChange}
                size="sm"
                isReadOnly
              />
            </Box>

            <Box
              display="flex"
              alignItems="center"
              boxShadow="md"
              borderRadius="8px"
              bg="white"
              p={3}
            >
              <FormLabel mb="0" minW="120px">
                Non-AC Rate
              </FormLabel>
              <Input
                bg="#FAFAFA"
                placeholder="Non-AC Rate"
                border="1px solid #ffe4d9"
                name="nonAcRate"
                value={formData.nonAcRate}
                onChange={handleInputChange}
                size="sm"
              />
            </Box>

            <Box
              display="flex"
              alignItems="center"
              boxShadow="md"
              borderRadius="8px"
              bg="white"
              p={3}
            >
              <FormLabel mb="0" minW="120px">
                Non-AC SGST
              </FormLabel>
              <Input
                bg="#FAFAFA"
                placeholder="SGST"
                border="1px solid #ffe4d9"
                name="nonAcSgst"
                value={formData.nonAcSgst}
                onChange={handleInputChange}
                size="sm"
                isReadOnly
              />
            </Box>

            <Box
              display="flex"
              alignItems="center"
              boxShadow="md"
              borderRadius="8px"
              bg="white"
              p={3}
            >
              <FormLabel mb="0" minW="120px">
                Non-AC CGST
              </FormLabel>
              <Input
                bg="#FAFAFA"
                placeholder="CGST"
                border="1px solid #ffe4d9"
                name="nonAcCgst"
                value={formData.nonAcCgst}
                onChange={handleInputChange}
                size="sm"
                isReadOnly
              />
            </Box>

            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              boxShadow="md"
              borderRadius="8px"
              bg="white"
              p={3}
            >
              <FormLabel mb="0">Half Available?</FormLabel>
              <Checkbox
                name="halfPlate"
                isChecked={formData.halfPlate}
                onChange={handleCheckboxChange}
              />
            </Box>

            {formData.halfPlate && (
              <>
                <Box
                  display="flex"
                  alignItems="center"
                  boxShadow="md"
                  borderRadius="8px"
                  bg="white"
                  p={3}
                >
                  <FormLabel mb="0" minW="120px">
                    AC Half Rate
                  </FormLabel>
                  <Input
                    bg="#FAFAFA"
                    placeholder="AC Half Rate"
                    border="1px solid #ffe4d9"
                    name="acHalfRate"
                    value={formData.acHalfRate}
                    onChange={handleInputChange}
                    size="sm"
                  />
                </Box>

                <Box
                  display="flex"
                  alignItems="center"
                  boxShadow="md"
                  borderRadius="8px"
                  bg="white"
                  p={3}
                >
                  <FormLabel mb="0" minW="120px">
                    AC Half SGST
                  </FormLabel>
                  <Input
                    bg="#FAFAFA"
                    placeholder="SGST"
                    border="1px solid #ffe4d9"
                    name="acHalfSgst"
                    value={formData.acHalfSgst}
                    onChange={handleInputChange}
                    size="sm"
                    isReadOnly
                  />
                </Box>

                <Box
                  display="flex"
                  alignItems="center"
                  boxShadow="md"
                  borderRadius="8px"
                  bg="white"
                  p={3}
                >
                  <FormLabel mb="0" minW="120px">
                    AC Half CGST
                  </FormLabel>
                  <Input
                    bg="#FAFAFA"
                    placeholder="CGST"
                    border="1px solid #ffe4d9"
                    name="acHalfCgst"
                    value={formData.acHalfCgst}
                    onChange={handleInputChange}
                    size="sm"
                    isReadOnly
                  />
                </Box>

                <Box
                  display="flex"
                  alignItems="center"
                  boxShadow="md"
                  borderRadius="8px"
                  bg="white"
                  p={3}
                >
                  <FormLabel mb="0" minW="140px">
                    Non-AC Half Rate
                  </FormLabel>
                  <Input
                    bg="#FAFAFA"
                    placeholder="Non-AC Half"
                    border="1px solid #ffe4d9"
                    name="nonAcHalfRate"
                    value={formData.nonAcHalfRate}
                    onChange={handleInputChange}
                    size="sm"
                  />
                </Box>

                <Box
                  display="flex"
                  alignItems="center"
                  boxShadow="md"
                  borderRadius="8px"
                  bg="white"
                  p={3}
                >
                  <FormLabel mb="0" minW="140px">
                    Non-AC Half SGST
                  </FormLabel>
                  <Input
                    bg="#FAFAFA"
                    placeholder="SGST"
                    border="1px solid #ffe4d9"
                    name="nonAcHalfSgst"
                    value={formData.nonAcHalfSgst}
                    onChange={handleInputChange}
                    size="sm"
                    isReadOnly
                  />
                </Box>

                <Box
                  display="flex"
                  alignItems="center"
                  boxShadow="md"
                  borderRadius="8px"
                  bg="white"
                  p={3}
                >
                  <FormLabel mb="0" minW="140px">
                    Non-AC Half CGST
                  </FormLabel>
                  <Input
                    bg="#FAFAFA"
                    placeholder="CGST"
                    border="1px solid #ffe4d9"
                    name="nonAcHalfCgst"
                    value={formData.nonAcHalfCgst}
                    onChange={handleInputChange}
                    size="sm"
                    isReadOnly
                  />
                </Box>
              </>
            )}

            <Box
              display="flex"
              alignItems="center"
              boxShadow="md"
              borderRadius="8px"
              bg="white"
              p={3}
            >
              <FormLabel mb="0" minW="100px">
                Image
              </FormLabel>
              <Input
                type="file"
                bg="#FAFAFA"
                border="1px solid #ffe4d9"
                onChange={handleFileChange}
                size="sm"
              />
              <Button
                ml={2}
                size="sm"
                variant="solid"
                onClick={handlePost}
                isLoading={uploading}
              >
                {uploading ? "Uploading" : "Upload"}
              </Button>
            </Box>
          </SimpleGrid>
        </Box>

        <Box mt={3} pb={2} display="flex" justifyContent="flex-end">
          <Button
            variant="solid"
            color="white"
            bg="#0F3D2E"
            _hover={{ color: "#0F3D2E", bg: "white" }}
            onClick={save}
          >
            Save
          </Button>
        </Box>
      </FormControl>
      <FoodCategoryModal
        isOpen={isOpen}
        onOpen={onOpen}
        onClose={onClose}
        customerId={customerId}
      />
    </Box>
  );
};

export default FoodRegister;
